import React from "react";
import SmartWaitingBadge from "./SmartWaitingBadge";

import { THEME_COLOR, LEVELS_MAP } from "../config/club";

const QueuePlayerGrid = ({
    queue,
    searchTerm,
    manualSelection,
    setManualSelection,
    playerLevels,
    gamesPlayed,
    levelColor,
    colsCount, 
    longWaitThreshold
}) => {

    const isLongWait = (waitingSince) => {
        if (!waitingSince) return false;
        const waitDate = new Date(waitingSince);
        const now = new Date();
        const diffInMinutes = (now - waitDate) / 1000 / 60;
        return diffInMinutes >= 15;
    };

    const filteredPlayers = queue.filter((p) =>
        p.name.toLowerCase().includes(searchTerm.toLowerCase())
    );



    if (filteredPlayers.length === 0) {
        return (
            <div className="text-center py-5 bg-surface rounded-4 border border-dashed">
                <i className="bi bi-person-dash fs-1 text-muted opacity-25"></i>
                <p className="text-muted mt-2">No players in queue matching “{searchTerm}”</p>
            </div>
        );
    }
    
    return (
        <div className="overflow-auto pe-2" style={{ maxHeight: "600px", scrollbarWidth: 'thin' }}>
            {/* <div className="row g-3"> */}
                <div className={`row row-cols-${colsCount} row-cols-md-${colsCount} row-cols-lg-${colsCount} row-cols-xl-${colsCount} g-3`}>
                {filteredPlayers.map((p) => {
                    const isSelected = manualSelection.some((x) => x.name === p.name);
                    const pLevel = playerLevels[p.name] || 1;
                    const longWait = isLongWait(p.waitingSince);
                    return (
                        //<div className="col-6 col-md-4 col-lg-3 col-xl-2" key={`${p.id}-queue-item`}>
                        <div className="col" key={`${p.id}-queue-item`}>
                            <div
                                onClick={() => {
                                    if (isSelected) {
                                        setManualSelection(manualSelection.filter((x) => x.name !== p.name));
                                    } else if (manualSelection.length < 4) {
                                        setManualSelection([...manualSelection, p]);
                                    }
                                }}
                                className={`queue-player-card card h-100 border-2 transition-all position-relative overflow-hidden cursor-pointer ${isSelected ? "shadow-md" : "shadow-sm"
                                    }`}
                                style={{
                                    borderRadius: "16px",
                                    borderColor: isSelected ? THEME_COLOR : "var(--border-color)",
                                    backgroundColor: isSelected
                                        ? `color-mix(in srgb, ${THEME_COLOR} 8%, var(--card-bg))`
                                        : "var(--card-bg)",
                                    transform: isSelected ? "scale(1.02)" : undefined,
                                    cursor: "pointer"
                                }}
                            >
                                {/* Selection Checkmark Overlay */}
                                {isSelected && (
                                    <div
                                        className="position-absolute top-0 end-0 p-2"
                                        style={{ zIndex: 2, color: THEME_COLOR }}
                                    >
                                        <i className="bi bi-check-circle-fill fs-5"></i>
                                    </div>
                                )}

                                {/* Level Accent Bar */}
                                <div style={{ height: '6px', backgroundColor: levelColor(pLevel) }}></div>

                                <div className="card-body p-3">
                                    <div
                                        className="fw-bold text-truncate mb-0"
                                        title={p.name}
                                        style={{ fontSize: '0.85rem', lineHeight: '1.2' }}
                                    >
                                        {p.name}
                                    </div>

                                    <div className="d-flex align-items-center gap-1 mb-1">
                                        <span
                                            className="badge text-dark border-0 fw-bold px-1"
                                            style={{
                                                fontSize: '0.6rem',
                                                backgroundColor: levelColor(pLevel),
                                                minWidth: '35px'
                                            }}
                                        >
                                            {LEVELS_MAP[pLevel]}
                                        </span>
                                        <span className="text-muted fw-medium" style={{ fontSize: '0.65rem' }}>
                                            • {gamesPlayed[p.name] || 0} games
                                        </span>
                                    </div>

                                    <SmartWaitingBadge waitingSince={p.waitingSince} longWaitThreshold={longWaitThreshold} />
                                    
                                </div>
                                <div style={{ height: '6px', backgroundColor: levelColor(pLevel) }}></div>
                            </div>
                            
                        </div>
                    );
                })}
            </div>

            <style>{`
        .cursor-pointer { cursor: pointer; }
        .transition-all { transition: all 0.2s ease-in-out; }
        .shadow-md { box-shadow: 0 8px 20px ${THEME_COLOR}25 !important; }
      `}</style>
        </div>
    );
};

export default QueuePlayerGrid;